import { Link } from 'react-router-dom';
import { useOptionalWorkspaceObjectives } from '@/lib/workspace-objectives';
import { hasCurrentWorkspaceObjectiveRef } from '@shared/types/workspace-objectives';

/** Only show a relationship explicitly cited by the decision, at its recorded version. */
export const ObjectiveContribution = ({ evidenceRefs }: { evidenceRefs: string[] }) => {
  const context = useOptionalWorkspaceObjectives();
  const linked = context?.objectives.filter((objective) =>
    objective.status === 'active' &&
    hasCurrentWorkspaceObjectiveRef(evidenceRefs, objective)
  ) ?? [];
  if (!linked.length) return null;
  return (
    <p className='mt-3 text-xs leading-5 text-domino-inkSoft'>
      Contribue à l’objectif : {linked.map((objective, index) => (
        <span key={objective.id}>
          {index > 0 ? ' · ' : ''}
          <Link to='/profil?tab=objectives' className='text-domino-aubergine underline underline-offset-2'>
            {objective.title}
          </Link>
        </span>
      ))}
    </p>
  );
};
